import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { Link } from 'dibs-elements/exports/Link';

export const alreadyConnectedMessage = (
    <FormattedMessage
        id="ethereum.alreadyConnected.body"
        defaultMessage="Your wallet is connected to another 1stDibs account. You must log in to your other 1stDibs account and disconnect the wallet before connecting your wallet to this account. Please <mailLink>contact support</mailLink> if you can’t access your other 1stDibs account."
        values={{
            mailLink: content => <Link href="mailto:support@1stdibs.com">{content}</Link>,
        }}
    />
);

export const EthereumConnectionAlreadyConnectedModal: FC<{
    isOpen: boolean;
    onClose: () => void;
}> = ({ isOpen, onClose }) => {
    return (
        <ModalContainer isOpen={isOpen} onClose={onClose}>
            <ModalCloseButton onClick={onClose} />
            <BarHeader
                title={
                    <FormattedMessage
                        id="ethereum.alreadyConnected.header"
                        defaultMessage="Could Not Connect Wallet"
                    />
                }
            />
            <ModalBody>
                <p>{alreadyConnectedMessage}</p>
            </ModalBody>
        </ModalContainer>
    );
};
